module.exports = __webpack_public_path__ + "img/beer-animation.ab3327e4.gif";